<template>
    <ul class="pagination">
        <li class="pagination page-nav" v-if="pagination.prev_page_url">
            <a href="#" @click.prevent="reloadData(pagination.prev_page_url)">{{ prevText ? prevText : ' &nbsp; &laquo; &nbsp; ' }}</a>
        </li>
        <li class="pagination page-nav" v-if="pagination.next_page_url">
            <a href="#" @click.prevent="reloadData(pagination.next_page_url)">{{ nextText ? nextText : ' &nbsp; &raquo; &nbsp; ' }}</a>
        </li>
    </ul>
</template>

<script setup>
import {ref, toRefs, watch} from 'vue';
import axios from 'axios';

const props = defineProps({
    nextText: String,
    prevText: String,
    value: Object,
});
const { nextText, prevText, value } = toRefs(props);
const pagination = ref({
    next_page_url: false,
    prev_page_url: false,
});

const emit = defineEmits(['loading-started', 'page-change-requested']);

watch(value, (newVal) => {
    pagination.value = newVal;
}, { immediate: true });

async function reloadData(url) {
    emit('loading-started');
    const res = await axios.get(url);
    let data = res.data;
    pagination.value = data;
    emit('page-change-requested', data.data);
}
</script>

<style scoped>

</style>
